import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type HospitalsSortOption = "newest" | "oldest" | "nameAsc" | "nameDesc";

export const DEFAULT_HOSPITALS_SORT_OPTION: HospitalsSortOption = "newest";

const OPTIONS: SortOption<HospitalsSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function hospitalsSortOptionLabel(option: HospitalsSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function hospitalsSortOptionToParams(option: HospitalsSortOption): {
  sortBy: "id" | "name";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "id", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "id", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "name", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "name", sortOrder: "DESC" };
  }
}

export default function SortHospitalsPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: HospitalsSortOption;
  setSortOption: (option: HospitalsSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Hospitals"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
